import { render } from "./scanComponent.vue?vue&type=template&id=189b8eab&scoped=true&lang=true"
import script from "./scanComponent.vue?vue&type=script&lang=js"
export * from "./scanComponent.vue?vue&type=script&lang=js"

import "./scanComponent.vue?vue&type=style&index=0&id=189b8eab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189b8eab"]])

export default __exports__